import script from "./SAM2Boxes.vue?vue&type=script&setup=true&lang=js"
export * from "./SAM2Boxes.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__